





























































































import Vue from 'vue';
import { Route } from 'vue-router';
import { setLocale, getLocale, SUPPORTED_LOCALES, SupportedLocale } from '@/services/i18n';

const FLAG_MAP: Record<string, string> = {
  ru: '🇷🇺',
  en: '🇬🇧',
  es: '🇪🇸',
  de: '🇩🇪',
};

interface RouterItem {
  id: string;
  title: string;
  href: string;
  isHidden: boolean;
  icon: {
    attributes: {
      type: string;
    };
  };
  external?: boolean;
  child?: RouterItem[];
  isLogout?: boolean;
}

export default Vue.extend({
  name: 'Sidebar',
  directives: {
    'click-outside': {
      bind(el: HTMLElement, binding: any) {
        (el as any).__clickOutside = (event: MouseEvent) => {
          if (!el.contains(event.target as Node)) {
            binding.value(event);
          }
        };
        document.addEventListener('click', (el as any).__clickOutside);
      },
      unbind(el: HTMLElement) {
        document.removeEventListener('click', (el as any).__clickOutside);
      },
    },
  },
  props: {
    routerList: {
      type: Array as () => RouterItem[],
      required: true,
    },
  },
  data() {
    return {
      sidebarCollapsed: true,
      activeKey: this.$router.currentRoute.name !== 'ReportDetail' ? [this.$router.currentRoute.name as string] : ['Report'],
      openKeys: [] as string[],
      locale: getLocale(),
      locales: SUPPORTED_LOCALES,
      selectOpen: false,
    };
  },
  computed: {
    isDarkTheme(): boolean {
      const theme = process.env.VUE_APP_THEME;
      return !theme || theme === 'dark';
    },
    currentLocaleLabel(): string {
      const found = SUPPORTED_LOCALES.find(l => l.code === this.locale);
      return found ? found.shortLabel : 'RU';
    },
    currentLocaleNativeName(): string {
      const found = SUPPORTED_LOCALES.find(l => l.code === this.locale);
      return found ? found.nativeName : '';
    },
    currentLocaleFlag(): string {
      return FLAG_MAP[this.locale] || '🌐';
    },
    languageLabel(): string {
      return this.$te('language.label')
        ? (this.$t('language.label') as string)
        : 'Language';
    },
  },
  methods: {
    getFlagEmoji(code: string): string {
      return FLAG_MAP[code] || '🌐';
    },
    translateNav(id: string, fallback: string): string {
      const key = `nav.${id}`;
      return this.$te(key) ? (this.$t(key) as string) : fallback;
    },
    handleLocaleChange(code: string) {
      const locale = code as SupportedLocale;
      this.locale = locale;
      setLocale(locale);
    },
    selectLocale(code: string) {
      this.handleLocaleChange(code);
      this.selectOpen = false;
    },
    closeSelect() {
      this.selectOpen = false;
    },
    onDropdownLocaleClick({ key }: { key: string }) {
      this.handleLocaleChange(key);
    },
    onSubMenuTitleClick(item: RouterItem): void {
      const isSubmenuOpen = this.openKeys.includes(item.id);
      
      if (isSubmenuOpen) {
        if (!this.sidebarCollapsed) {
          this.openKeys = this.openKeys.filter(key => key !== item.id);
        }
      } else {
        this.openKeys.push(item.id);
      }

      if (this.sidebarCollapsed) {
        this.sidebarCollapsed = false;
      }
    },
    onItemClick(event: MouseEvent, item: RouterItem): void {
      if (item.isLogout) {
        this.$emit('logout');
      } else if (item.external) {
        window.open(
          item.href,
          '_self',
          item.id === 'Support' ? 'left=20,top=20,width=550,height=650,toolbar=1,resizable=0' : undefined
        );
      } else {
        if (item.id === 'Support') {
            window.open(
                `${window.location.origin}${item.href}`,
                '_blank',
                'left=20,top=20,width=550,height=650,toolbar=1,resizable=0'
            );
        } else {
            this.$router.push(item.href);
        }
      }
    },
  },
  watch: {
    $route(to: Route) {
      if (to.name === 'ReportDetail') {
        this.activeKey = ['Report'];
      } else {
        this.activeKey = [to.name as string];
      }
    },
    sidebarCollapsed() {
      this.selectOpen = false;
    },
  },
});
